import { lazy } from 'react';
import { decryptUserStorage } from '@reducers/UserSlice';

import { Permissions } from '../../utils/constants/permissions';

import { SettingsPaths } from './settingsPaths';
const CrmSettingsRouter = lazy(() => import('../crm-settings/CrmSettingsRouter'));
const RobotoCallsRouter = lazy(() => import('../roboto-calls/RobotoCallsRouter'));

const SettingHome = lazy(() => import('../../pages/settingHome/SettingHome'));
const SettingEmployee = lazy(() => import('../../pages/settingEmployee/SettingEmployee'));
const MessageRouter = lazy(() => import('../messageConfigRoutes/MessageRouter'));
const HouseConfig = lazy(() => import('../../pages/houseConfig/HouseConfig'));
const BuilderSettings = lazy(() => import('../../pages/builderSettings/BuilderSettings'));
const InterfaceConfigRouter = lazy(() => import('../interfaceConfig/InterfaceConfigRouter'));
const CompanyConfigRouter = lazy(() => import('../companyConfig/CompanyConfigRouter'));
const DiscountRouter = lazy(() => import('../discount/DiscountRouter'));
const Shaxmatka = lazy(() => import('../../pages/shaxmatka/Shaxmatka'));
const ImportExportRouter = lazy(() => import('../importExport/ImportExportRouter'));
const SettingBranch = lazy(() => import('../../pages/settingBranch/SettingBranch'));
const PaymentSettingsRouter = lazy(() => import('../paymentSettings/PaymentSettingsRouter'));
const IntegrationRouter = lazy(() => import('../integration/IntegrationRouter'));
const Kpi = lazy(() => import('../../pages/kpi'));
const EventList = lazy(() => import('../../pages/activityLogs/ActivityLogs'));
const SectionSettings = lazy(() => import('../../pages/section-settings'));
const SecuritySettingsRouter = lazy(() => import('../securitySettings/SecuritySettingsRouter'));

const user = decryptUserStorage;

const routes = [
  {
    path: SettingsPaths.INDEX,
    component: SettingHome,
    exact: true
  },
  {
    path: SettingsPaths.EMPLOYEE,
    component: SettingEmployee,
    exact: true,
    permission: Permissions.PERMISSION_SETTINGS_EMPLOYEE
  },
  {
    path: SettingsPaths.MESSAGE,
    component: MessageRouter,
    permission: Permissions.PERMISSION_SETTINGS_MESSAGE,
    exact: false
  },
  {
    path: SettingsPaths.HOUSE_CONFIG,
    component: HouseConfig,
    exact: true,
    permission: Permissions.PERMISSION_SETTINGS_HOUSE
  },
  {
    path: SettingsPaths.HOUSE_CONFIG + SettingsPaths.SHAXMATKA,
    component: Shaxmatka,
    exact: true,
    permission: Permissions.PERMISSION_SETTINGS_HOUSE
  },
  {
    path: SettingsPaths.BUILDER,
    component: BuilderSettings,
    exact: true,
    permission: Permissions.PERMISSION_SETTINGS_BUILDER
  },
  {
    path: SettingsPaths.INTERFACE,
    component: InterfaceConfigRouter,
    exact: false,
    permission: Permissions.PERMISSION_SETTINGS_INTERFACE
  },
  {
    path: SettingsPaths.COMPANY_CONFIG,
    component: CompanyConfigRouter,
    exact: false,
    permission: Permissions.PERMISSION_SETTINGS_COMPANY
  },
  {
    path: SettingsPaths.DISCOUNT,
    component: DiscountRouter,
    exact: false,
    permission: Permissions.PERMISSION_SETTINGS_DISCOUNT
  },
  {
    path: SettingsPaths.BACKUP,
    component: ImportExportRouter,
    exact: false,
    permission: Permissions.PERMISSION_SETTINGS_TRANSFER_DATA
  },
  {
    path: SettingsPaths.BRANCH,
    component: SettingBranch,
    exact: true,
    permission: Permissions.PERMISSION_SETTINGS_BRANCH
  },
  {
    path: SettingsPaths.PAYMENT,
    component: PaymentSettingsRouter,
    exact: false,
    permission: Permissions.PERMISSION_SETTINGS_PAYMENT
  },
  {
    path: SettingsPaths.INTEGRATION,
    component: IntegrationRouter,
    exact: false,
    permission: Permissions.PERMISSION_INTEGRATION
  },
  {
    path: SettingsPaths.KPI,
    component: Kpi,
    exact: true,
    permission: Permissions.PERMISSION_SETTINGS_KPI
  },
  {
    path: SettingsPaths.EVET_LIST,
    component: EventList,
    exact: true,
    permission: Permissions.PERMISSION_ACTIVITY_LOGS
  },
  {
    path: SettingsPaths.SECURITY,
    component: SecuritySettingsRouter,
    exact: false,
    permission: Permissions.PERMISSION_COMPANY_ROLE
  },
  {
    path: SettingsPaths.CRM_SETTINGS,
    component: CrmSettingsRouter,
    exact: false,
    permission: Permissions.PERMISSION_SETTINGS_CRM
  },
  {
    path: SettingsPaths.CALLS,
    component: RobotoCallsRouter,
    exact: false,
    permission: Permissions.PERMISSION_SETTINGS_CRM
  },
  {
    path: SettingsPaths.SECTION,
    component: SectionSettings,
    expect: false,
    permission: Permissions.PERMISSION_SETTINGS_SECTION
  }
];

const settingRoutes: typeof routes = [];

if (typeof user === 'object' && user) {
  routes.forEach(route => {
    if (route.permission) {
      if (user.role?.permissions?.includes(route.permission)) {
        settingRoutes.push(route);
      }
    } else {
      settingRoutes.push(route);
    }
  });
}

export default settingRoutes;
